// extracted by mini-css-extract-plugin
module.exports = {"phone-in-use__buttons":"PhoneInUse_phone-in-use__buttons__sNyaC","title":"PhoneInUse_title__UTIJr","subtitle":"PhoneInUse_subtitle__Mrqen","text":"PhoneInUse_text__HeD_O"};